// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"619b30d2","366":"186fed06","503":"34dd9a55","846":"131980f5"}[chunkId] + ".chunk.js";
};